export default {
  leftCol: {
    notCollect: "Emblem erhebt bei diesem Vorgang keine Daten",
    proofOfAge: "Ihr Altersnachweis ermöglicht es niemandem, Ihre Online-Aktivitäten nachzuvollziehen",
  },
  rightColIntro: {
    title: "Altersüberprüfung",
    poweredBy: "angetrieben von",
    stateLaw: "Nach deutschem Recht müssen Sie nachweisen, dass Sie mindestens 18 Jahre alt sind",
    emblemPartner: "Wir haben mit Emblem zusammengearbeitet – einem vertrauenswürdigen System zur Altersüberprüfung.",
    safeSimple: "Es ist sicher, einfach und nur einmal erforderlich.",
    verifyNow: "Jetzt Prüfen",
    alreadyVerified: "Bereits verifiziert?",
    login: "Anmeldung",
  },
  rightColQR: {
    switchToMobile: "Wechseln Sie zum Mobilgerät",
    verificationRequires: "Für die Verifizierung ist ein mobiles Gerät erforderlich",
    howToContinue: "Wie es weitergeht",
    one: "1. Öffnen Sie die Kamera auf Ihrem Mobilgerät.",
    two: "2. Scannen Sie den QR-Code.",
    three: "3. Folgen Sie den Schritten auf Ihrem Bildschirm."
  }
}